let _users = [];
try {
  _users = JSON.parse(process.env.REACT_APP_ALLOWED_USERS_JSON || "[]");
} catch {
  _users = [];
}

// Fallback: if the JSON env var is missing/malformed, use the single-user env vars
if (_users.length === 0 && process.env.REACT_APP_USERNAME) {
  _users = [{ u: process.env.REACT_APP_USERNAME, p: process.env.REACT_APP_PASSWORD }];
}

export const USERS = _users;
